import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule,
  ]
})
export class LoaderComponent  implements OnInit {

  constructor(
    public loaderService: LoaderService
  ) { }

  ngOnInit() {}

}
